import React, { useEffect } from "react";
import {
  Grid,
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import { FormattedDate, FormattedNumber } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { selectFullExportLink } from "../../selectors";
import { fetchProfile } from "../../actions";
import { useQuery } from "react-query";
import { LoadingIndicator } from "../common/loading-indicator";

const COUNTRY_LABELS = {
  usa: "U.S.",
  canada: "Canadian",
  europe: "European",
};

export const CountryExport = ({ country, exportLink }) => {
  const { status, data } = useQuery(`/api/export-run?country=${country}`);

  if (status === "loading") return <LoadingIndicator />;

  if (!data || !data.created_at) {
    return (
      <p style={{ fontStyle: "italic", color: "#666" }}>
        No {COUNTRY_LABELS[country]} export available yet.
      </p>
    );
  }

  const {
    created_at: createdAt,
    archive_size_bytes: archiveSize,
    number_of_securities: numberOfSecurities,
  } = data;

  const downloadLink = exportLink ? `${exportLink}?country=${country}` : null;

  return (
    <>
      <ListGroup>
        <ListGroupItem header="Last Export Completed At">
          <FormattedDate
            year="numeric"
            month="short"
            day="2-digit"
            hour="numeric"
            minute="numeric"
            value={createdAt}
          />
        </ListGroupItem>
        <ListGroupItem header="Number of Securities">
          <FormattedNumber value={numberOfSecurities} />
        </ListGroupItem>
        <ListGroupItem header="Archive Size">
          <FormattedNumber
            style="unit"
            value={Math.round(archiveSize / 1000)}
            unit="kilobyte"
            unitDisplay="narrow"
          />
        </ListGroupItem>
      </ListGroup>
      {downloadLink && (
        <div align="center" style={{ margin: "24px" }}>
          <Button
            id={`download-export-button-${country}`}
            type="submit"
            href={downloadLink}
          >
            Download {COUNTRY_LABELS[country]} Archive
          </Button>
        </div>
      )}
    </>
  );
};

export const PremiumExport = ({ exportLink }) => {
  return (
    <>
      <h4>U.S. Archive</h4>
      <CountryExport country="usa" exportLink={exportLink} />

      <h4 style={{ marginTop: "32px" }}>Canadian Archive</h4>
      <CountryExport country="canada" exportLink={exportLink} />

      <h4 style={{ marginTop: "32px" }}>European Archive</h4>
      <CountryExport country="europe" exportLink={exportLink} />
    </>
  );
};

export const ManagePremium = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchProfile);
  }, []);
  const fullExportLink = useSelector(selectFullExportLink);

  return (
    <Grid>
      <Row>
        <Col xs={12} md={12}>
          <PremiumExport exportLink={fullExportLink} />
        </Col>
      </Row>
    </Grid>
  );
};
